import React from 'react'

const User = () => {
  return (
    <div>
      <h1>User Data</h1>
    </div>
  )
}

export default User;
